import { Controller } from "@hotwired/stimulus"

/** Reporting showcase: Goal Setting (pace card) vs full dashboard; backdrops + intros per tab. */
export default class extends Controller {
  static targets = ["tab", "backdrop", "intro", "panel", "visual"]

  connect() {
    const selected = this.tabTargets.find((t) => t.getAttribute("aria-selected") === "true")
    const key = selected?.dataset.reportingTab || this.tabTargets[0]?.dataset.reportingTab
    if (key) this.show(key)
  }

  select(event) {
    const key = event.currentTarget.dataset.reportingTab
    if (key) this.show(key)
  }

  show(key) {
    this.tabTargets.forEach((btn) => {
      const on = btn.dataset.reportingTab === key
      btn.setAttribute("aria-selected", on ? "true" : "false")
      btn.setAttribute("tabindex", on ? "0" : "-1")
      btn.classList.toggle("bg-gray-950", on)
      btn.classList.toggle("text-white", on)
      btn.classList.toggle("shadow-sm", on)
      btn.classList.toggle("ring-1", on)
      btn.classList.toggle("ring-white/10", on)
      btn.classList.toggle("text-gray-500", !on)
      btn.classList.toggle("hover:text-gray-200", !on)
    })

    this.backdropTargets.forEach((el) => {
      const on = el.dataset.reportingBackdrop === key
      el.classList.toggle("opacity-100", on)
      el.classList.toggle("opacity-0", !on)
    })

    this.introTargets.forEach((el) => {
      const on = el.dataset.reportingIntro === key
      el.hidden = !on
      el.classList.toggle("hidden", !on)
    })

    this.panelTargets.forEach((panel) => {
      const on = panel.dataset.reportingPanel === key
      panel.hidden = !on
      panel.classList.toggle("hidden", !on)
    })

    // Map tab keys to visual keys
    const visualMap = { goal_setting: "goal", attendance: "attendance", attribution: "attribution" }
    const activeVisual = visualMap[key] || "goal"

    this.visualTargets.forEach((el) => {
      const on = el.dataset.reportingVisual === activeVisual
      el.classList.toggle("opacity-100", on)
      el.classList.toggle("opacity-0", !on)
      el.classList.toggle("pointer-events-none", !on)
      el.classList.toggle("z-20", on)
      el.classList.toggle("z-0", !on)
      el.setAttribute("aria-hidden", on ? "false" : "true")
    })
  }
}
